<form [formGroup]="searchForm">
  <div class="flex gap-4">
    <div class="w-1/4">
      <app-input-group>
        <label appLabel>{{ 'vee.meteringpoint.type' | translate }}</label>
        <select appSelect [collection]="meteringPointTypeOptions" formControlName="meteringPointType">
        </select>
      </app-input-group>
    </div>

    <div class="w-1/4">
      <app-input-group>
        <label appLabel>{{ 'vee.meteringpoint.id' | translate }}</label>
        <input type="text" appInput formControlName="meteringPointIdentification" [placeholder]="'vee.meteringpoint.id' | translate">
      </app-input-group>
    </div>

    <div class="w-1/4"></div>
    <div class="w-1/4"></div>
  </div>
  <div class="flex gap-4">
    <div class="w-1/4">
      <app-input-group>
        <label appLabel>{{ 'vee.meteringpoint.streetName' | translate }}</label>
        <input type="text" appInput formControlName="streetName"[placeholder]="'vee.meteringpoint.streetName' | translate">
      </app-input-group>
    </div>

    <div class="w-1/4">
      <app-input-group>
        <label appLabel>{{ 'vee.meteringpoint.streetNumber' | translate }}</label>
        <input type="text" appInput formControlName="streetNumber" [placeholder]="'vee.meteringpoint.streetNumber' | translate" >
      </app-input-group>
    </div>

    <div class="w-1/4">
      <app-input-group>
        <label appLabel>{{ 'vee.meteringpoint.postalCode' | translate }}</label>
        <input type="number" appInput formControlName="postalCode" [placeholder]="'vee.meteringpoint.postalCode' | translate">
      </app-input-group>
    </div>
    <div class="w-1/4"></div>
  </div>
  <div class="flex gap-4">
    <div class="w-1/4">
      <app-input-group>
        <label appLabel>{{ 'vee.meteringpoint.estimationGroupName' | translate }}</label>
        <input type="text" appInput formControlName="estimationGroupName" [placeholder]="'vee.meteringpoint.estimationGroupName' | translate" >
      </app-input-group>
    </div>

    <div class="w-1/4">
      <app-input-group>
        <label appLabel>{{ 'vee.meteringpoint.meteringPointNoEstimationGroup' | translate }}</label>
       <select appInput formControlName="meteringPointNoEstimationGroup">
         <option disabled selected value="null">{{ 'common.select' | translate }}</option>
         <option [ngValue]="true">{{ 'common.yes' | translate }}</option>
         <option [ngValue]="false">{{ 'common.no' | translate }}</option>
       </select>
      </app-input-group>
    </div>

    <div class="w-1/4"></div>
    <div class="w-1/4"></div>
  </div>
  <div class="mb-4">
    <button appButton (click)="table?.search()" [disabled]="!searchForm.valid">
      {{ 'common.search' | translate }}
    </button>
  </div>
</form>

<app-table
  #table
  [config]="tableConfig"
  [(selectedElements)]="selectedElements"
></app-table>
